// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pIcon {
  float: right;
}

.font {
  font-weight: bold;
  font-size: 36px;
}

.top-bottom-mar {
  margin-top: 0;
  margin-bottom: 0;
}

.txt {
  font-weight: bold;
  font-size: 16px;
}

.remove-cart-link {
  font-size: 8px;
  color: #707070;
}

.mb0 {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cart-added-popup/cart-added-popup.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AACA;EACI,iBAAA;EACA,eAAA;AAEJ;;AAAA;EACI,aAAA;EACA,gBAAA;AAGJ;;AADA;EACI,iBAAA;EACA,eAAA;AAIJ;;AAFA;EACI,cAAA;EACA,cAAA;AAKJ;;AAHA;EACI,gBAAA;AAMJ","sourcesContent":[".pIcon {\n    float: right;\n}\n.font {\n    font-weight: bold;\n    font-size: 36px;\n}\n.top-bottom-mar {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.txt {\n    font-weight: bold;\n    font-size: 16px;\n}\n.remove-cart-link{\n    font-size: 8px;\n    color: #707070;\n}\n.mb0{\n    margin-bottom: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
